/**
 * Free Gifts System - Optimized
 * Auto adds/removes gifts based on cart subtotal
 */

(function() {
  'use strict';

  const GIFT_TIERS = [
    {
      tier: 1,
      threshold: 100000,
      gifts: [
        { handle: 'free-bamboo-pocket-tissues', quantity: 1 },
        { handle: 'free-gift-natural-clean-toothbrush-charcoal-bristles', quantity: 1 }
      ]
    },
    {
      tier: 2,
      threshold: 150000,
      gifts: [
        { handle: 'anti-static-bamboo-paddle-hair-brush-round', quantity: 1 }
      ]
    },
    {
      tier: 3,
      threshold: 200000,
      gifts: [
        { handle: 'free-gift-eco-luxe-stainless-steel-wine-tumbler-black', quantity: 1 },
        { handle: 'eco-luxe-stainless-steel-wine-tumbler-rose-gold', quantity: 1 }
      ]
    }
  ];

  const ALL_GIFT_HANDLES = GIFT_TIERS.flatMap(tier => tier.gifts.map(g => g.handle));
  const productCache = {};
  let isProcessing = false;
  let lastCartState = null;
  let pendingConfetti = false;

  function init() {
    createModalContainer();

    // Batch initial setup
    requestAnimationFrame(() => {
      loadProductImages();
      initProductSliders();
      initGiftCardClicks();
      initCartGiftClicks();
    });

    // Initialize previous tier from DOM
    const section = document.querySelector('.free-gifts-section');
    if (section && section.dataset.activeTier) {
      previousActiveTier = parseInt(section.dataset.activeTier) || 0;
    }

    if (typeof theme !== 'undefined' && theme.pubsub) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    }

    document.addEventListener('cart:updated', handleCartUpdatedEvent);

    // Listen for cart drawer refresh
    document.addEventListener('cart:refresh', () => {
      // Show pending confetti immediately
      if (pendingConfetti) {
        showHeartConfetti();
        pendingConfetti = false;
      }

      requestAnimationFrame(() => {
        loadProductImages();
        initProductSliders();
        initGiftCardClicks();
        initCartGiftClicks();
      });
    });

    // Observe DOM changes to detect when gift section is re-rendered
    observeGiftSection();

    // Initial check with slight delay
    setTimeout(checkAndUpdateGifts, 300);
  }

  /**
   * Initialize click handlers for free gift items in cart
   */
  function initCartGiftClicks() {
    // Cart drawer items
    const drawerGiftItems = document.querySelectorAll('.horizontal-product.is-free-gift');
    // Cart page items (table rows)
    const pageGiftItems = document.querySelectorAll('tr.cart-item.is-free-gift');

    const allGiftItems = [...drawerGiftItems, ...pageGiftItems];

    allGiftItems.forEach(item => {
      if (item.dataset.giftClickInit === 'true') return;
      item.dataset.giftClickInit = 'true';

      // Make it clickable
      item.style.cursor = 'pointer';

      item.addEventListener('click', (e) => {
        // Don't trigger on quantity input or other interactive elements
        if (e.target.closest('input, button, a')) return;

        e.preventDefault();
        e.stopPropagation();

        const handle = item.dataset.handle;
        if (handle) {
          openSingleGiftModal(handle);
        }
      });
    });
  }

  /**
   * Open modal for a single gift product (from cart item click)
   */
  async function openSingleGiftModal(handle) {
    const overlay = document.getElementById('giftModal');
    const productsContainer = document.getElementById('giftModalProducts');
    const tierInfo = document.getElementById('giftModalTierInfo');
    const titleEl = document.getElementById('giftModalTitle');

    if (!overlay) return;

    titleEl.textContent = "Your Valentine's Gift";
    productsContainer.innerHTML = '<div style="text-align: center; padding: 2rem; color: #999;">Loading...</div>';
    tierInfo.innerHTML = '<span class="gift-modal__tier-status is-unlocked">🎉 This gift is yours!</span>';

    // Open modal
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    try {
      const product = await getFullProductData(handle);
      if (product) {
        productsContainer.innerHTML = `
          <div class="gift-modal__product">
            <div class="gift-modal__product-image">
              <img src="${product.image}" alt="${product.title}" loading="lazy">
            </div>
            <div class="gift-modal__product-info">
              <h3 class="gift-modal__product-name">${product.title}</h3>
              <div class="gift-modal__product-price">
                <span class="gift-modal__product-original">₹${(product.price / 100).toLocaleString('en-IN')}</span>
                <span class="gift-modal__product-free">FREE</span>
              </div>
              ${product.description ? `<p class="gift-modal__product-desc">${product.description}</p>` : ''}
            </div>
          </div>
        `;
      }
    } catch (error) {
      productsContainer.innerHTML = '<div style="text-align: center; padding: 1rem; color: #999;">Gift details unavailable</div>';
    }
  }

  /**
   * Create modal container
   */
  function createModalContainer() {
    if (document.querySelector('.gift-modal-overlay')) return;

    const modalHTML = `
      <div class="gift-modal-overlay" id="giftModal">
        <div class="gift-modal">
          <div class="gift-modal__header">
            <span class="gift-modal__title">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
              <span id="giftModalTitle">Gift Details</span>
            </span>
            <button class="gift-modal__close" id="giftModalClose">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="gift-modal__content">
            <div class="gift-modal__products" id="giftModalProducts"></div>
            <div class="gift-modal__tier-info" id="giftModalTierInfo"></div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    // Close handlers
    const overlay = document.getElementById('giftModal');
    const closeBtn = document.getElementById('giftModalClose');

    closeBtn.addEventListener('click', closeGiftModal);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeGiftModal();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeGiftModal();
    });
  }

  /**
   * Initialize gift card click handlers
   */
  function initGiftCardClicks() {
    const cards = document.querySelectorAll('.free-gift-card');

    cards.forEach(card => {
      // Skip if already initialized
      if (card.dataset.clickInit === 'true') return;
      card.dataset.clickInit = 'true';

      card.addEventListener('click', (e) => {
        // Don't trigger if clicking on dots
        if (e.target.closest('.free-gift-card__slider-dots')) return;

        const tier = parseInt(card.dataset.tier);
        const handles = card.dataset.handles?.split(',') || [];
        const threshold = parseInt(card.dataset.threshold);

        openGiftModal(tier, handles, threshold, card);
      });
    });
  }

  /**
   * Open gift modal with product details
   */
  async function openGiftModal(tier, handles, threshold, card) {
    const overlay = document.getElementById('giftModal');
    const productsContainer = document.getElementById('giftModalProducts');
    const tierInfo = document.getElementById('giftModalTierInfo');
    const titleEl = document.getElementById('giftModalTitle');

    if (!overlay) return;

    // Update title based on tier
    const tierConfig = GIFT_TIERS.find(t => t.tier === tier);
    const giftCount = tierConfig?.gifts?.length || handles.length;
    titleEl.textContent = giftCount > 1 ? `${giftCount} Valentine's Gifts` : "Valentine's Gift";

    // Show loading state
    productsContainer.innerHTML = '<div style="text-align: center; padding: 2rem; color: #999;">Loading gifts...</div>';

    // Check tier status - is it active, passed, or locked
    const section = document.querySelector('.free-gifts-section');
    const currentSubtotal = parseInt(section?.dataset?.subtotal || 0);
    const currentActiveTier = parseInt(section?.dataset?.activeTier || 0);
    const isUnlocked = currentSubtotal >= threshold;
    const isActive = currentActiveTier === tier;
    const isPassed = isUnlocked && !isActive && tier < currentActiveTier;
    const remaining = Math.ceil((threshold - currentSubtotal) / 100);

    // Dynamic status text based on tier state
    if (isActive) {
      tierInfo.innerHTML = `<span class="gift-modal__tier-status is-unlocked">🎉 This gift is yours!</span>`;
    } else if (isPassed) {
      tierInfo.innerHTML = `<span class="gift-modal__tier-status" style="color: #6b7280;">✨ You've upgraded to a better gift!</span>`;
    } else {
      tierInfo.innerHTML = `<span class="gift-modal__tier-status">💝 Add ₹${remaining} more to unlock this gift</span>`;
    }

    // Open modal
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Load product details in parallel for speed
    const productPromises = handles.map(handle => getFullProductData(handle));
    const products = await Promise.all(productPromises);

    let productsHTML = '';
    products.forEach(product => {
      if (product) {
        productsHTML += `
          <div class="gift-modal__product">
            <div class="gift-modal__product-image">
              <img src="${product.image}" alt="${product.title}" loading="lazy">
            </div>
            <div class="gift-modal__product-info">
              <h3 class="gift-modal__product-name">${product.title}</h3>
              <div class="gift-modal__product-price">
                <span class="gift-modal__product-original">₹${(product.price / 100).toLocaleString('en-IN')}</span>
                <span class="gift-modal__product-free">FREE</span>
              </div>
              ${product.description ? `<p class="gift-modal__product-desc">${product.description}</p>` : ''}
            </div>
          </div>
        `;
      }
    });

    productsContainer.innerHTML = productsHTML || '<div style="text-align: center; padding: 1rem; color: #999;">Gift details unavailable</div>';
  }

  /**
   * Close gift modal
   */
  function closeGiftModal() {
    const overlay = document.getElementById('giftModal');
    if (overlay) {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  /**
   * Get full product data including description
   */
  async function getFullProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();

      let imageUrl = '';
      if (product.featured_image) {
        imageUrl = product.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_300x300.$1');
      } else if (product.images && product.images.length > 0) {
        imageUrl = product.images[0].replace(/\.(jpg|jpeg|png|gif|webp)/i, '_300x300.$1');
      }

      // Strip HTML from description and truncate
      let description = product.description || '';
      description = description.replace(/<[^>]*>/g, '').trim();
      if (description.length > 150) {
        description = description.substring(0, 150) + '...';
      }

      return {
        title: product.title,
        price: product.price,
        image: imageUrl,
        description: description
      };
    } catch (error) {
      console.error(`Failed to fetch product ${handle}:`, error);
      return null;
    }
  }

  /**
   * Observe gift section for DOM changes (AJAX updates)
   */
  function observeGiftSection() {
    let debounceTimer = null;

    const reloadContent = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        requestAnimationFrame(() => {
          loadProductImages();
          initProductSliders();
          initGiftCardClicks();
          initCartGiftClicks();
        });
      }, 100);
    };

    const reloadImages = reloadContent;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if any added node contains gift products
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) {
              if (node.classList?.contains('free-gifts-section') ||
                  node.classList?.contains('free-gift-card') ||
                  node.querySelector?.('.free-gift-card__product[data-handle]')) {
                reloadImages();
                return;
              }
            }
          }
        }
      }
    });

    // Observe multiple possible containers
    const containers = [
      document.querySelector('cart-drawer'),
      document.querySelector('[id^="MiniCart-"]'),
      document.querySelector('.cart-drawer'),
      document.querySelector('[data-cart-drawer]'),
      document.querySelector('#cart-drawer'),
      document.body
    ].filter(Boolean);

    // Observe the first valid container
    const targetContainer = containers[0];
    if (targetContainer) {
      observer.observe(targetContainer, {
        childList: true,
        subtree: true
      });
    }

    // Also listen for section rendering complete
    document.addEventListener('shopify:section:load', reloadImages);

    // Fallback: Check every 3 seconds if cart drawer is visible and images need loading
    setInterval(() => {
      const cartDrawer = document.querySelector('cart-drawer[open], .cart-drawer.is-open, [data-cart-drawer][open]');
      if (cartDrawer) {
        const unloadedImages = document.querySelectorAll('.free-gift-card__product-img img[src=""], .free-gift-card__product-img img:not([src])');
        if (unloadedImages.length > 0) {
          requestAnimationFrame(loadProductImages);
        }
        // Also reinit clicks for cart gift items
        initCartGiftClicks();
      }
    }, 3000);
  }

  /**
   * Initialize product sliders with auto-slide and dots
   */
  function initProductSliders() {
    const sliders = document.querySelectorAll('.free-gift-card__products-slider[data-count="2"]');

    sliders.forEach(slider => {
      // Skip if already initialized
      if (slider.dataset.initialized === 'true') return;
      slider.dataset.initialized = 'true';

      const track = slider.querySelector('.free-gift-card__products-track');
      const products = slider.querySelectorAll('.free-gift-card__product');
      if (!track || products.length < 2) return;

      // Create dots container
      let dotsContainer = slider.parentElement.querySelector('.free-gift-card__slider-dots');
      if (!dotsContainer) {
        dotsContainer = document.createElement('div');
        dotsContainer.className = 'free-gift-card__slider-dots';
        dotsContainer.dataset.count = products.length;

        products.forEach((_, index) => {
          const dot = document.createElement('span');
          dot.className = 'free-gift-card__slider-dot' + (index === 0 ? ' is-active' : '');
          dot.dataset.index = index;
          dot.addEventListener('click', () => goToSlide(index));
          dotsContainer.appendChild(dot);
        });

        slider.after(dotsContainer);
      }

      let currentSlide = 0;
      let autoSlideInterval;

      function goToSlide(index) {
        currentSlide = index;
        track.style.transform = `translateX(-${index * 50}%)`;

        // Update dots
        const dots = dotsContainer.querySelectorAll('.free-gift-card__slider-dot');
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function nextSlide() {
        const nextIndex = (currentSlide + 1) % products.length;
        goToSlide(nextIndex);
      }

      function startAutoSlide() {
        stopAutoSlide();
        autoSlideInterval = setInterval(nextSlide, 3000);
      }

      function stopAutoSlide() {
        if (autoSlideInterval) {
          clearInterval(autoSlideInterval);
        }
      }

      // Start auto-slide
      startAutoSlide();

      // Pause on hover
      slider.addEventListener('mouseenter', stopAutoSlide);
      slider.addEventListener('mouseleave', startAutoSlide);
    });
  }

  /**
   * Show heart confetti effect
   */
  function showHeartConfetti() {
    // Remove existing container if any
    const existing = document.querySelector('.heart-confetti-container');
    if (existing) existing.remove();

    const container = document.createElement('div');
    container.className = 'heart-confetti-container';

    const hearts = ['❤️', '💕', '💖', '💗', '💝', '💘', '🩷'];
    const numHearts = 25;

    for (let i = 0; i < numHearts; i++) {
      const heart = document.createElement('span');
      heart.className = 'heart-confetti';
      heart.textContent = hearts[Math.floor(Math.random() * hearts.length)];
      heart.style.left = `${Math.random() * 100}%`;
      heart.style.animationDelay = `${Math.random() * 0.5}s`;
      heart.style.fontSize = `${1 + Math.random() * 1.5}rem`;
      container.appendChild(heart);
    }

    document.body.appendChild(container);

    // Remove after animation
    setTimeout(() => {
      container.remove();
    }, 3500);
  }

  let previousActiveTier = 0;

  async function loadProductImages() {
    const productElements = document.querySelectorAll('.free-gift-card__product[data-handle]');

    for (const element of productElements) {
      const handle = element.dataset.handle;
      if (!handle) continue;

      const imgElement = element.querySelector('.free-gift-card__product-img img');

      // Check if image needs loading (empty src attribute or placeholder)
      const srcAttr = imgElement?.getAttribute('src') || '';
      const needsLoad = !srcAttr || srcAttr === '' || srcAttr.includes('placeholder');

      if (!needsLoad && imgElement?.complete && imgElement?.naturalWidth > 0) {
        continue; // Image already loaded successfully
      }

      try {
        const productData = await getProductData(handle);
        if (productData) {
          if (imgElement && productData.image) {
            imgElement.src = productData.image;
            imgElement.alt = productData.title;
          }

          const nameElement = element.querySelector('.free-gift-card__product-name');
          if (nameElement && productData.title) {
            nameElement.textContent = productData.title;
          }
        }
      } catch (error) {
        console.warn(`Failed to load product data for ${handle}:`, error);
      }
    }
  }

  function handleCartUpdate(event) {
    if (event.source === 'free-gifts') return;
    checkAndUpdateGifts();

    // Reload images after cart update (DOM may have changed)
    setTimeout(loadProductImages, 300);
  }

  function handleCartUpdatedEvent(event) {
    if (event.detail?.source === 'free-gifts') return;
    checkAndUpdateGifts();

    // Reload images after cart update (DOM may have changed)
    setTimeout(loadProductImages, 300);
  }

  async function checkAndUpdateGifts() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart = await fetchCart();
      if (!cart) {
        isProcessing = false;
        return;
      }

      // Quick hash to detect if cart actually changed
      const cartHash = `${cart.item_count}-${cart.total_price}`;
      if (lastCartState === cartHash) {
        isProcessing = false;
        return;
      }
      lastCartState = cartHash;

      const subtotal = calculateSubtotal(cart);
      const activeTier = getActiveTier(subtotal);
      const currentGiftsInCart = getGiftsInCart(cart);

      // Check if tier is upgrading BEFORE sync
      const tierUpgrading = activeTier > previousActiveTier && activeTier > 0;

      // Show confetti IMMEDIATELY when tier upgrades (before cart sync)
      if (tierUpgrading) {
        showHeartConfetti();
        pendingConfetti = false;
      }

      const cartChanged = await syncGifts(activeTier, currentGiftsInCart, subtotal);

      // If cart will change, set pending confetti for after refresh
      if (cartChanged && tierUpgrading) {
        pendingConfetti = true;
      }

      updateCardUI(subtotal, activeTier);

      if (tierUpgrading) {
        scrollToActiveCard(activeTier);
      }
      previousActiveTier = activeTier;

      // Batch DOM updates
      requestAnimationFrame(() => {
        loadProductImages();
        initProductSliders();
        initCartGiftClicks();
      });
    } catch (error) {
      console.error('Free Gifts Error:', error);
    } finally {
      isProcessing = false;
    }
  }

  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch cart:', error);
      return null;
    }
  }

  function calculateSubtotal(cart) {
    let subtotal = 0;
    cart.items.forEach(item => {
      const isFreeGift = item.properties && item.properties._free_gift === 'true';
      if (!isFreeGift) {
        subtotal += item.final_line_price;
      }
    });
    return subtotal;
  }

  function getActiveTier(subtotal) {
    let activeTier = 0;
    for (const tierConfig of GIFT_TIERS) {
      if (subtotal >= tierConfig.threshold) {
        activeTier = tierConfig.tier;
      }
    }
    return activeTier;
  }

  function getGiftsInCart(cart) {
    return cart.items.filter(item => {
      return item.properties && item.properties._free_gift === 'true';
    });
  }

  async function syncGifts(activeTier, currentGiftsInCart, subtotal) {
    const targetGifts = activeTier > 0
      ? GIFT_TIERS.find(t => t.tier === activeTier)?.gifts || []
      : [];

    const targetHandles = targetGifts.map(g => g.handle);
    const currentGiftHandles = currentGiftsInCart.map(item => item.handle);

    const giftsToRemove = currentGiftsInCart.filter(item =>
      !targetHandles.includes(item.handle)
    );

    const giftsToAdd = targetGifts.filter(gift =>
      !currentGiftHandles.includes(gift.handle)
    );

    let cartChanged = false;

    // Batch remove operations
    const removePromises = giftsToRemove.map(item => removeFromCart(item.key));
    if (removePromises.length > 0) {
      await Promise.all(removePromises);
      cartChanged = true;
    }

    // Batch add operations
    const addPromises = giftsToAdd.map(gift => addToCart(gift.handle, gift.quantity));
    if (addPromises.length > 0) {
      await Promise.all(addPromises);
      cartChanged = true;
    }

    if (cartChanged) {
      refreshCartUI();
    }

    return cartChanged;
  }

  async function getProductData(handle) {
    if (productCache[handle]) {
      return productCache[handle];
    }

    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      const variant = product.variants.find(v => v.available) || product.variants[0];

      let imageUrl = '';
      if (product.featured_image) {
        imageUrl = product.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_150x150.$1');
      } else if (product.images && product.images.length > 0) {
        imageUrl = product.images[0].replace(/\.(jpg|jpeg|png|gif|webp)/i, '_150x150.$1');
      }

      productCache[handle] = {
        productId: product.id,
        variantId: variant.id,
        title: product.title,
        image: imageUrl,
        price: variant.price
      };

      return productCache[handle];
    } catch (error) {
      console.error(`Failed to fetch product ${handle}:`, error);
      return null;
    }
  }

  async function addToCart(handle, quantity) {
    const productData = await getProductData(handle);
    if (!productData) return;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: productData.variantId,
            quantity: quantity,
            properties: { '_free_gift': 'true' }
          }]
        })
      });

      if (!response.ok) throw new Error('Failed to add gift');
      return await response.json();
    } catch (error) {
      console.error(`Failed to add gift ${handle}:`, error);
    }
  }

  async function removeFromCart(lineKey) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });

      if (!response.ok) throw new Error('Failed to remove gift');
      return await response.json();
    } catch (error) {
      console.error('Failed to remove gift:', error);
    }
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { source: 'free-gifts', open: false }
    }));

    // Reload product images after cart refresh
    setTimeout(() => {
      loadProductImages();
    }, 300);
  }

  /**
   * Update card UI with correct states
   */
  function updateCardUI(subtotal, activeTier) {
    const cards = document.querySelectorAll('.free-gift-card');

    cards.forEach(card => {
      const tier = parseInt(card.dataset.tier);
      const threshold = parseInt(card.dataset.threshold);
      const isUnlocked = subtotal >= threshold;
      const isActive = tier === activeTier;
      const isPassed = isUnlocked && !isActive;

      // Update classes
      card.classList.toggle('is-unlocked', isUnlocked);
      card.classList.toggle('is-active', isActive);
      card.classList.toggle('is-passed', isPassed);

      // Update progress bar - using direct style width with absolute positioning
      const progressBar = card.querySelector('.free-gift-card__progress-bar');
      const progress = Math.min((subtotal / threshold) * 100, 100);
      if (progressBar) {
        const displayWidth = progress > 0 && progress < 5 ? 5 : progress;
        progressBar.style.width = `${displayWidth.toFixed(1)}%`;
      }

      // Update badge - Valentine's Theme
      const badge = card.querySelector('.free-gift-card__badge');
      if (badge) {
        badge.classList.toggle('is-active', isActive);
        badge.classList.toggle('is-passed', isPassed);

        if (isActive) {
          badge.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg> Yours`;
        } else if (isPassed) {
          badge.textContent = 'Upgraded';
        } else {
          badge.textContent = '💔 Locked';
        }
      }

      // Update status text - Valentine's Theme
      const status = card.querySelector('.free-gift-card__status');
      if (status) {
        if (isActive) {
          if (tier === 3) {
            status.innerHTML = '💖 Full love unlocked!';
          } else if (tier === 2) {
            status.innerHTML = '💗 Made for you!';
          } else {
            status.innerHTML = '💕 Yours with love!';
          }
        } else if (isPassed) {
          status.textContent = 'More love awaits!';
        } else {
          const remaining = Math.ceil((threshold - subtotal) / 100);
          if (remaining <= 100) {
            status.innerHTML = `₹${remaining} to max love!`;
          } else if (remaining <= 300) {
            status.innerHTML = `₹${remaining} more love!`;
          } else {
            status.innerHTML = `₹${remaining} to unlock love`;
          }
        }
      }
    });

    // Update section data
    const section = document.querySelector('.free-gifts-section');
    if (section) {
      section.dataset.activeTier = activeTier;
      section.dataset.subtotal = subtotal;
    }

    // Auto-scroll to active card with smooth behavior
    scrollToActiveCard(activeTier);
  }

  /**
   * Scroll carousel to show the active gift card
   */
  function scrollToActiveCard(activeTier) {
    if (activeTier <= 0) return;

    // Small delay to ensure DOM is updated
    setTimeout(() => {
      const carousels = document.querySelectorAll('.free-gifts-carousel');

      carousels.forEach(carousel => {
        const activeCard = carousel.querySelector(`.free-gift-card[data-tier="${activeTier}"]`);
        if (!activeCard) return;

        const carouselRect = carousel.getBoundingClientRect();
        const cardRect = activeCard.getBoundingClientRect();

        // Calculate optimal scroll position to center the card (or show it prominently)
        const cardOffsetLeft = activeCard.offsetLeft;
        const cardWidth = activeCard.offsetWidth;
        const carouselWidth = carousel.offsetWidth;

        // Center the card in view
        const scrollLeft = cardOffsetLeft - (carouselWidth / 2) + (cardWidth / 2);

        carousel.scrollTo({
          left: Math.max(0, scrollLeft),
          behavior: 'smooth'
        });
      });
    }, 100);
  }

  function isGiftProduct(handle) {
    return ALL_GIFT_HANDLES.includes(handle);
  }

  window.FreeGifts = {
    init,
    checkAndUpdateGifts,
    isGiftProduct,
    loadProductImages,
    scrollToActiveCard,
    openGiftModal,
    openSingleGiftModal,
    closeGiftModal,
    initCartGiftClicks,
    GIFT_TIERS
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
